export default {
    methods: {
        showContextMenu(event, ref) {
            event.preventDefault();

            if (this.$refs[ref] == undefined) {
                return false;
            }

            const currentContextMenu = this.$refs[ref];
            const eventX = event.pageX;
            const eventY = event.pageY;


            currentContextMenu.show();

            this.$nextTick(() => {

                const contextmenuPosition = {
                    top: eventY,
                    left: eventX,
                }

                const contextmenuWidth = currentContextMenu.$el.clientWidth
                const contextmenuHeight = currentContextMenu.$el.clientHeight

                if (contextmenuHeight + eventY >= window.innerHeight) {
                    contextmenuPosition.top -= contextmenuHeight
                }
                if (contextmenuWidth + eventX >= window.innerWidth) {
                    contextmenuPosition.left -= contextmenuWidth
                }

                currentContextMenu.style = {
                    top: `${contextmenuPosition.top}px`,
                    left: `${contextmenuPosition.left}px`,
                };
            })
        },
    }
}